import React from 'react'
import AssetsTable from 'atoms/AssetsTable'
import { motion } from 'framer-motion'
import { ToDoListRow } from 'atoms/AssetsTable'
import { useState } from 'react'

import {
  TableContainer,
  TableRow,
  Box,
  Typography,
  TableBody,
  Table,
  TableCell,
} from '@mui/material'
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material'

// TODO: GENERATE TODO LIST ITEMS
const rows = [
  {
    header: 'Contribute at least 5% to your TSP',
  },
  {
    header: 'Open a Roth IRA',
  },
  {
    header: 'Set up a Will',
  },
  {
    header: 'Add a military buyback',
  },
]

function ToDoList({ items }) {
  const [open, setOpen] = useState([])
  const [hoveredRow, setHoveredRow] = useState(null)

  const toDoItems = items || rows

  const isActive = (index) => open.includes(index)

  const handleRowClick = (index) => {
    //this will open the todolist item in whatever we have
    toDoItems[index].onClick
      ? toDoItems[index].onClick()
      : console.log('no action')
  }

  const getRowColor = (index) => {
    if (hoveredRow === index) {
      return isActive(index) ? '#f1f1f1' : '#f9f9f9'
    }
    return isActive(index) ? '#f1f1f1' : 'inherit'
  }

  const renderExpandableRow = (index) => (
    <>
      <TableRow
        onMouseEnter={() => setHoveredRow(index)}
        onMouseLeave={() => setHoveredRow(null)}
        onClick={() => handleRowClick(index)}
        sx={{
          cursor: 'pointer',
          backgroundColor: getRowColor(index),
          //   padding: '8px',
          transition: 'background-color 0.2s ease-in-out',
          borderBottom: '1px solid #e9ecef',
          '&:last-of-type, &>td': {
            borderBottom: 'none',
          },
        }}
      >
        <TableCell
          colSpan={1}
          sx={{
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            width: '25px',
            paddingLeft: { xs: '12px', md: '24px' },
            paddingRight: '0px',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            {toDoItems[index].completed ? (
              <CheckCircle
                sx={{
                  color: '#4F8DF0',
                  height: '30px',
                  width: '30px',
                }}
              />
            ) : (
              <RadioButtonUnchecked
                sx={{
                  color: '#4F8DF0',
                  height: '30px',
                  width: '30px',
                }}
              />
            )}
          </Box>
        </TableCell>
        <TableCell colSpan={4} sx={{ paddingLeft: '10px' }}>
          <Typography variant="body1">{toDoItems[index].header}</Typography>
        </TableCell>
        <TableCell colSpan={1} sx={{}}>
          <Box
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <svg
              width="20"
              height="19"
              viewBox="0 0 14 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.03072 12.973L5.71396 11.669L9.65785 7.72514H0.0761719V5.82031H9.65785L5.71396 1.88281L7.03072 0.572443L13.231 6.77273L7.03072 12.973Z"
                fill="#4F8DF0"
              />
            </svg>
          </Box>
        </TableCell>
      </TableRow>
    </>
  )

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, ease: 'easeInOut' }}
    >
      <Typography display="flex" align="left" variant="body2FunHeader" mb={2}>
        TO DO LIST
      </Typography>

      <TableContainer
        sx={{
          margin: 'auto',
          // width: '100%',
          // borderTopLeftRadius: 0,
          // borderTopRightRadius: 0,
        }}
      >
        <Table aria-label="collapsible table">
          <TableBody sx={{}}>
            {toDoItems.map((row, i) => (
              <React.Fragment key={i}>{renderExpandableRow(i)}</React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </motion.div>
  )
}

export default ToDoList
